import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { captureException, init } from '@sentry/angular';

if (typeof window !== 'undefined') {
    init({
        dsn: 'https://666e817bdfaff57cea17dbb60d65d196@o4508314012155904.ingest.de.sentry.io/4510617198919760',
        sendDefaultPii: true,
    });
}

bootstrapApplication(AppComponent, appConfig).catch((error: unknown) => {
    captureException(error);
    console.error(error);
});
